import React from 'react';

import Text from '../../common/Text';
import Tooltip from '../../common/Tooltip';
import Locale from '../../Translate';
import { Trans } from 'react-i18next';

interface ClaimsValueProps {
  currency?: string;
  value?: number;
  id: string;
}

export const currencySigns: Record<string, string> = {
  EUR: '€',
  CHF: 'CHF',
  CZK: 'Kč',
  DKK: 'kr',
  GBP: '£',
  HUF: 'ft',
  NOK: 'kr',
  PLN: 'zł',
  RON: 'lei',
  SEK: 'kr',
};

function ClaimsValue({ currency, value, id }: ClaimsValueProps) {
  if (!value) {
    return (
      <div data-tip data-for={`${id}-net-value-tooltip`}>
        <Text ink>
          <Locale>No value</Locale>
        </Text>
        <Tooltip id={`${id}-net-value-tooltip`} position="top">
          <Trans i18nKey="CLAIM_DRAFT_NO_NET_VALUE_TOOLTIP" />
        </Tooltip>
      </div>
    );
  }

  return <Text ink>{`${currencySigns[currency || '']} ${(value / 100).toLocaleString('en-US')}`}</Text>;
}

export default ClaimsValue;
